import { useState } from "react";
import "../styles/Marketing.css";

import img1 from "../assets/aruhkonceptmarketing.png";
import img2 from "../assets/mayuinfra.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Marketing() {

  const navigate=useNavigate();
  const projects = [
    {
      image: img1,
      title: "Aruh Koncepts",
      category: "Digital Marketing",
      link: "#",
    },
    {
      image: img2,
      title: "Mayu Infra",
      category: "Brand Promotion",
      link: "#",
    }
  ];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === projects.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? projects.length - 1 : prev - 1
    );
  };

  return (
    <section className="marketing">
      <h2>Marketing</h2>

      <p className="marketing-description">
        We're a dynamic digital marketing agency committed
        to making your business thrive. Whether you're a
        seasoned player in the digital landscape or just
        stepping into it, we have the expertise and
        strategies to propel your brand.
      </p>

      <div className="marketing-slider">

        <img
          src={projects[current].image}
          alt={projects[current].title}
          className="marketing-image"
        />

        {/* Bottom Left Arrows */}
        <div className="slider-arrows">
          <button onClick={prevSlide}>
            <FaArrowLeft />
          </button>

          <button onClick={nextSlide}>
            <FaArrowRight />
          </button>
        </div>

        {/* Bottom Right Button */}
        <a
          href={projects[current].link}
          className="case-study-btn"
          onClick={()=>{navigate("/digitalcasestudy")}}
        >
          View Case Study
        </a>
      </div>

      <div className="project-details">
        <h3>{projects[current].title}</h3>
        <p>{projects[current].category}</p>
      </div>
      <div className="marketing-view">
      <button className="view-more-btn" onClick={()=>{navigate("/digitalcasestudy")}}>View More</button>
    </div>
    </section>
  );
}

export default Marketing;